import { ChangeDetectionStrategy, Component, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { GetTeamsQueryResult, TeamCardComponent } from '@teams';

@Component({
  selector: 'lib-dashboard-teams',
  templateUrl: './dashboard-teams.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TeamCardComponent]
})
export class DashboardTeamsComponent {
  readonly teams: InputSignal<GetTeamsQueryResult[]> = input.required<GetTeamsQueryResult[]>();

  readonly isTeamsExpanded: WritableSignal<boolean> = signal<boolean>(true);

  changeTeamsVisibility(): void {
    this.isTeamsExpanded.update((value: boolean) => !value);
  }
}
